/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import axios from 'axios';
import urlJoin from 'proper-url-join';

import type { StoreQueryParams } from '../../../../ts';
import { CatalogItem } from '../../../../ts/catalog';
import { endpoints } from '../../../ia/util/config';

const endpoint = id => urlJoin(`${endpoints.store}/v2/assistants`, id);

export const listCatalogIntegrations = (
  assistantId: string,
  params?: StoreQueryParams
) =>
  axios
    .get(urlJoin(endpoint(assistantId), '/catalog/integrations'), {
      params
    })
    .then(response => response.data);

export const getCatalogItem = (
  assistantId: string,
  catalogItemId: string,
  params?: StoreQueryParams
) =>
  axios
    .get(
      urlJoin(endpoint(assistantId), `/catalog/integrations`, catalogItemId),
      {
        params
      }
    )
    .then(response => response.data);

export const updateCatalogIntegrationInstance = (
  assistantId: string,
  data: CatalogItem
): Promise<any> => {
  return axios
    .post(
      urlJoin(
        endpoint(assistantId),
        `/catalog/integrations`,
        data.catalog_item_id
      ),
      data
    )
    .then(response => response.data);
};

export const createCatalogIntegrationInstance = (
  assistantId: string,
  data
): Promise<any> => {
  return axios
    .post(urlJoin(endpoint(assistantId), '/catalog/integrations'), data)
    .then(response => response.data);
};

export const deleteCatalogItem = (
  assistantId: string,
  catalogItemId: string
): Promise<void> =>
  axios
    .delete(
      urlJoin(endpoint(assistantId), '/catalog/integrations', catalogItemId),
      { params: { removeInstances: true } }
    )
    .then(response => response.data);
